window.app = window.app || {};

window.app.products_carousel = {
  el: {
    productsSlider: document.querySelector(".mt-products-carousel .swiper"),
  },
  productsSlider: null,

  init: function () {
    this.productsSlider = new Swiper(this.el.productsSlider, {
      slidesPerView: 2,
      loop: true,
      spaceBetween: 30,
      navigation: {
        prevEl: ".mt-products-carousel .arrow-left",
        nextEl: ".mt-products-carousel .arrow-right",
      },
      speed: 500,
      preventInteractionOnTransition: true,
      breakpoints: {
        700: {
          slidesPerView: 3,
        },
        992: {
          slidesPerView: 4,
        },
      },
    });
  },
};

window.addEventListener("DOMContentLoaded", () => {
  window.app.products_carousel.init();
});
